import { defineComponent, h } from 'vue';
import {QCard, QImg, QCardSection, QToolbar, QToolbarTitle, QSpace, QBtn, QInput, QTabs, QTab, QTabPanels, QTabPanel, QCardActions, QIcon} from 'quasar';
import methods from '../../Shared/methods';
import utils from '../../Shared/utils.jsx';
import Bar from '../../Assets/Bar.png';
import BarWithLine from '../../Assets/BarWithLine.png';
import BlankCard from '../../Assets/BlankCard.jpg';
import Donut from '../../Assets/Donut.png';
import Numeric from '../../Assets/Numeric.png';
import Table from '../../Assets/Table.png';

import TranslationContainer from './TranslationContainer.jsx';

export default defineComponent({
    name: 'card-browser',
    components: {
        TranslationContainer,
        QCard,
        QImg,
        QCardSection,
        QToolbar,
        QToolbarTitle,
        QSpace,
        QBtn,
        QInput,
        QSpace,
        QTabs,
        QTab,
        QTabPanels,
        QTabPanel,
        QCardActions,
        QIcon
    },
    data: () => ({
        selected_tab: 'dashboard',
        dashboardCards: [],
        reportCards: [],
        filter: '',
        selectedCardId: '',
        imageMap: {
            "Bar": Bar,
            "BarWithLine": BarWithLine,
            "Donut": Donut,
            "Numeric": Numeric,
            "Table": Table,
        }
    }),
    props: {
        confirm: null,
        cancel: null,
    },
    async created() {},
    mounted() {
        this.Refresh();
    },
    methods: {
        ...methods,
        async Refresh() {
            var allCards = await utils.api.get('Apps/Platform/Schema/RealTime/v1/WidgetDefinition/ListAllPossibleByID');
            var dCards = allCards.DashboardCards;
            await this.getThumbnails(dCards);
            this.dashboardCards = dCards;

            this.reportCards = allCards.ReportCards;
        },
        returnControl(id, title) {
            this.confirm(id, title);
            this.selectedCardId = null;
        },
        search(value) {
            this.filter = value;
        },
        highlightCard(card) {
            this.selectedCardId = card.ID;
        },
        select() {
            if(this.dashboardCards.length == 0)
                return;
            
            let selectedCard = this.dashboardCards.find(c => c.ID == this.selectedCardId);
            if(selectedCard && !selectedCard?.UserControl)
                return;
            else if (!selectedCard) {
                selectedCard = this.reportCards.find(c => c.ID == this.selectedCardId);
                if(!selectedCard)
                    return;
            }

            this.confirm(selectedCard);
            this.selectedCardId = null;
        },
        async getThumbnails(widgetDefs){
            widgetDefs.forEach(w => {
                w.thumbnail = this.imageMap[w.Image] || BlankCard;
            })
           
            return;
        },
        getCardStyle(card) {
            if (card.ID == this.selectedCardId) {
                return {
                    border: "2px solid var(--v-primaryActive-base)"
                };
            }
            
            // Add a transparent border to prevent layout shifts when selected
            return {
                border: "2px solid transparent"
            };
        }
    },
    render() {
        let ditems;
        if (this.dashboardCards.length > 0){
            ditems = this.dashboardCards.filter(c => ((!this.filter || c.Name.toLowerCase().includes(this.filter.toLowerCase())) && c.UserControl)).map(c => (
                <div class="col-4 q-pa-xs">
                    <QCard 
                        class="cursor-pointer q-pa-sm" 
                        style={{ height: "100%", wordBreak: "normal", ...this.getCardStyle(c) }} 
                        onClick={() => this.highlightCard(c)}
                    >
                        <QImg src={c.thumbnail}/>
                        <QCardSection class="q-pa-xs text-body1">{c.Name}</QCardSection>
                    </QCard>
                </div>
            ));
        }
        else
            ditems = ditems = <div class="col-12 text-center q-pa-md"><TranslationContainer context={this} value={"Loading..."}/></div>;

        let ritems;
        if (this.reportCards.length > 0){
            ritems = this.reportCards.filter(c => !this.filter || c.Name.toLowerCase().includes(this.filter.toLowerCase()) ).map(c => (
                <div class="col-4 q-pa-xs">
                    <QCard 
                        class="cursor-pointer q-pa-sm" 
                        style={{ height: "100%", wordBreak: "normal", ...this.getCardStyle(c) }}
                        onClick={() => this.highlightCard(c)} 
                    >
                        {c.thumbnail && <QImg src={c.thumbnail} />}
                        <QCardSection class="q-pa-xs text-body1"> {c.Name} </QCardSection>
                        <QCardSection class="q-pa-xs text-caption text-grey-6" style={{ display: 'flex', alignItems: 'center' }} >
                            {(() => {
                                const getSharedByText = (card, users, context) => {
                                    if (card.IsSystem) {
                                        return <TranslationContainer context={context} value={'System'} />;
                                    } else if (users && users[card.CreatedBy]?.fullname) {
                                        return users[card.CreatedBy].fullname;
                                    } else {
                                        return <TranslationContainer context={context} value={'Unknown'} />;
                                    }
                                };
                                return (
                                    <div style="display: flex; gap: 4px;">
                                        <TranslationContainer context={this} value={"Shared By:"} /> 
                                        {getSharedByText(c, utils.global_variables?.Users, this)}
                                    </div>
                                );
                            })()}
                        </QCardSection>
                    </QCard>
                </div>
            ));
        }
        else
            ritems = <div class="col-12 text-center q-pa-md"><TranslationContainer context={this} value={"No Reports available"}/></div>; 

        return (
            <QCard style={{height:'715px', maxHeight:'715px', width:'860px', maxWidth:'100vw', display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
                <QToolbar class="text-white" style={{ backgroundColor: 'var(--v-navigation-base)', maxHeight: '60px', height: '60px', flexShrink: 0 }}>
                    <QToolbarTitle class="q-pl-none text-h6">
                        <TranslationContainer context={this} value="Add new card"></TranslationContainer>
                    </QToolbarTitle>

                    <QSpace></QSpace>

                    <QBtn flat round dense icon="mdi-close" text-color="white" onClick={this.cancel}></QBtn>
                </QToolbar>

                <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }} class="q-my-md q-mx-lg row">
                    <QInput
                        class="quick-search-input"
                        dense hide-bottom-space
                        clearable clear-icon="mdi-close-circle"
                        placeholder={this.Translate ? this.Translate("Quick Search") : "Quick Search"}
                        modelValue={this.filter}
                        onUpdate:modelValue={(value) => this.search(value)}
                    >
                        {{ prepend: () => <QIcon name="mdi-magnify" /> }}
                    </QInput>
                    <QSpace />
                    <QBtn flat round icon="mdi-refresh" class="q-ma-xs" onClick={() => this.Refresh()}></QBtn>
                </div>

                <div class="c-BasicTab q-px-lg" style={{ flexShrink: 0 }}>
                    <QTabs 
                        align="left" 
                        indicatorColor="transparent"
                        breakpoint={0}
                        style={{ color: 'var(--v-secondaryText-base)' }}
                        modelValue={this.selected_tab} 
                        onUpdate:modelValue={(val) => this.selected_tab = val}
                    >
                        <QTab name="dashboard"><TranslationContainer context={this} value="Dashboard Cards"/></QTab>
                        <QTab name="reports"><TranslationContainer context={this} value="Shared Reports"/></QTab>
                    </QTabs>
                </div>

                <QTabPanels
                    modelValue={this.selected_tab}
                    animated
                    style={{ padding: '0 10px 0 18px', flex: '1 1 auto', minHeight: 0, overflow: 'auto', scrollbarGutter: 'stable both-edges' }}
                >
                    <QTabPanel name="dashboard" class="q-pa-sm">
                        <div class="row q-col-gutter-sm">
                            {ditems}
                        </div>
                    </QTabPanel>
                    <QTabPanel name="reports" class="q-pa-sm">
                        <div class="row q-col-gutter-sm">
                            {ritems}
                        </div>
                    </QTabPanel>
                </QTabPanels>
                
                <QCardActions align="right" class="q-mt-sm" style={{ flexShrink: 0 }}>
                    <QBtn color="primary" unelevated no-caps class="q-ma-xs c-SentenceCaseButton" onClick={() => this.select()}><TranslationContainer context={this} value="Add"/></QBtn>
                </QCardActions>
            </QCard>
        );
    }
});